var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLadder = function SvgIconLadder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.774 2.75h7.476a1 1 0 1 1 0 2h-.8l-.76 2.094 4.75 13.064a1 1 0 0 1-1.88.683L16.89 16h-4.53l-1.67 4.592a1 1 0 0 1-1.88-.684l.603-1.658H5.542l-.852 2.342a1 1 0 1 1-1.88-.684l1.064-2.925q.021-.076.054-.148l3.214-8.839a1 1 0 0 1 .063-.173L8.323 4.75H8.25a1 1 0 1 1 0-2h1.524M13.087 14h3.076l-1.538-4.23-1.19 3.27a1 1 0 0 1-.036.101zm1.236-9.25-.91 2.5H9.543l.909-2.5zm-8.054 11.5h3.872l.909-2.5H7.178zm1.636-4.5.91-2.5h3.871l-.909 2.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLadder;